import type { ReadonlySignal, Signal } from "@suse-o11y/signal";
import { useRequiredContext } from "@suse-o11y/use-required-context";
import { createContext } from "react";

import type { SpecificRange, TimeRange } from "../../../app/state/view/timeline/TimeRange";
import type { DashboardVariable } from "../../../common/dashboard-spec";

import type { DashboardState } from "./_dashboard-state";

export interface DashboardContextValue {
	timeRange: Signal<TimeRange>;
	chartTimeRange: ReadonlySignal<SpecificRange>;
	refreshChartTimeRange: VoidFunction;
	variables: Signal<ReadonlyArray<DashboardVariable>>;
	state: DashboardState;
}

const DashboardContext = createContext<null | DashboardContextValue>(null);

export const DashboardContextProvider = DashboardContext.Provider;

export function useDashboardContext(): DashboardContextValue {
	return useRequiredContext(DashboardContext, {
		providerName: "DashboardProvider",
	});
}
